var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPremium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99891 1.97806C7.02505 1.93058 7.06345 1.89099 7.11012 1.86341C7.15678 1.83584 7.20999 1.82129 7.26419 1.82129C7.31839 1.82129 7.3716 1.83584 7.41826 1.86341C7.46493 1.89099 7.50333 1.93058 7.52947 1.97806L9.31742 5.37225C9.36006 5.45084 9.41957 5.51902 9.49167 5.57189C9.56378 5.62476 9.64671 5.66101 9.73448 5.67803C9.82226 5.69505 9.91272 5.69243 9.99937 5.67035C10.086 5.64827 10.1667 5.60728 10.2356 5.55032L12.8261 3.33114C12.8758 3.29069 12.9371 3.26707 13.0011 3.26366C13.0651 3.26026 13.1285 3.27726 13.1823 3.31221C13.236 3.34715 13.2773 3.39825 13.3001 3.45814C13.323 3.51803 13.3262 3.58362 13.3094 3.64548L11.5929 9.8512C11.5579 9.97819 11.4824 10.0903 11.3779 10.1705C11.2734 10.2507 11.1456 10.2947 11.0139 10.2958H3.51508C3.38324 10.2948 3.25531 10.2509 3.1507 10.1707C3.04609 10.0905 2.97052 9.97828 2.93545 9.8512L1.21958 3.64609C1.20277 3.58423 1.20603 3.51863 1.22887 3.45874C1.25172 3.39886 1.29298 3.34776 1.34671 3.31281C1.40045 3.27786 1.46388 3.26087 1.52789 3.26427C1.5919 3.26767 1.65318 3.2913 1.70291 3.33174L4.29276 5.55092C4.36169 5.60788 4.44237 5.64887 4.52901 5.67095C4.61566 5.69304 4.70612 5.69566 4.79389 5.67864C4.88167 5.66161 4.96459 5.62537 5.0367 5.5725C5.10881 5.51963 5.16832 5.45145 5.21096 5.37286L6.99891 1.97806Z",
    fill: "url(#paint0_linear_4543_12298)",
    stroke: "url(#paint1_linear_4543_12298)",
    strokeWidth: 1.21134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02734 12.7188H11.5068",
    stroke: "url(#paint2_linear_4543_12298)",
    strokeWidth: 1.21134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4543_12298",
    x1: 1.20898,
    y1: 6.05852,
    x2: 13.32,
    y2: 6.05852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4543_12298",
    x1: 1.20898,
    y1: 6.05852,
    x2: 13.32,
    y2: 6.05852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4543_12298",
    x1: 3.02734,
    y1: 13.2188,
    x2: 11.5068,
    y2: 13.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8904"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPremium);
export default __webpack_public_path__ + "static/media/icon_premium.fcc976934caf87810989501bdf48b3a3.svg";
export { ForwardRef as ReactComponent };